import React, { useRef, useState } from 'react';
import classnames from 'classnames';

export default function Tabs({ tabs }) {
  const [currentTab, setCurrentTab] = useState(0);
  const [loadedTabs, setLoadedTabs] = useState([0]); // Track loaded tabs
  const tabRefs = useRef({});

  const onKeyDown = (event) => {
    const setIndex = (index) => {
      setCurrentTab(index);
      setLoadedTabs((prev) => [...new Set([...prev, index])]); // Mark tab as loaded
      const tab = tabRefs.current[index];
      if (tab) {
        tab.focus();
      }
    };

    const count = tabs.length;
    const nextTab = () => setIndex((currentTab + 1) % count);
    const prevTab = () => setIndex((currentTab - 1 + count) % count);
    const firstTab = () => setIndex(0);
    const lastTab = () => setIndex(count - 1);

    const keyMap = {
      ArrowRight: nextTab,
      ArrowLeft: prevTab,
      Home: firstTab,
      End: lastTab,
    };

    const action = keyMap[event.key];

    if (action) {
      event.preventDefault();
      action();
    }
  };

  return (
    <>
      <div
        role="tablist"
        aria-orientation="horizontal"
        className="tabs tabs__steps"
      >
        {tabs.map((tab, index) => (
          <button
            key={index}
            role="tab"
            ref={(element) => (tabRefs.current[index] = element)}
            aria-selected={currentTab === index}
            onClick={() => {
              setCurrentTab(index);
              setLoadedTabs((prev) => [...new Set([...prev, index])]); // Mark tab as loaded
            }}
            onFocus={() => {
              setCurrentTab(index);
              setLoadedTabs((prev) => [...new Set([...prev, index])]); // Mark tab as loaded
            }}
            onKeyDown={onKeyDown}
            tabIndex={currentTab === index ? 0 : -1}
            className={classnames('tabs__steps-title', 'tabs__btn', {
              'tabs__steps-title--active': index === currentTab,
            })}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {tabs.map((tab, index) => {
        return (
          <section
            key={index}
            hidden={index !== currentTab}
            role="tabpanel"
            aria-label={tab.name}
            tabIndex="0"
          >
            {/* lazy load component via loadedTabs so that we don't fetch all the data at once */}
            {loadedTabs.includes(index) && tab.component}
          </section>
        );
      })}
    </>
  );
}
